import React, {
  Children, cloneElement, useCallback, useEffect, useState
} from "react";
import PropTypes from "prop-types";
import { useLazyGetVehiclesResourceQuery } from "../redux/vehicle.api";
import {
  useLazyGetVehicleWeekMileagesResourceQuery, usePatchVehicleWeekMileagesResourceMutation,
  usePostVehicleWeekMileagesResourceMutation
} from "../../vehicleWeekMileagesResource/redux/vehicleWeekMileagesResource.api";
import { useLazyGetTrackPointsResourceQuery } from "../../trackPointsResource/redux/trackPointsResource.api";
import useAuth from "../../../../shared/lib/hooks/useAuth";
// eslint-disable-next-line boundaries/element-types
import { useGetAppUserResourceIdQuery } from "../../../account/appUsersResource/redux/appUsersResource.api";
import { useLazyGetVehicleMonthMileagesResourceQuery, usePatchVehicleMonthMileagesResourceMutation, usePostVehicleMonthMileagesResourceMutation } from "../../vehicleMonthMileagesResource/redux/vehicleMonthMileagesResource.api";

// Компонента Бизнес уровня которая является связующим звеном между фронтом и бизнесом
// Компонента возвращает Children с новыми пропсами из бизнес уровня
function VehicleReportingBll({
  children, vehicle, company
}) {
  // TODO: переписать token на стор
  // eslint-disable-next-line no-undef
  const token = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

  const { user } = useAuth();

  const { data: dataAppUser } = useGetAppUserResourceIdQuery(
    {
      id: user.appUserId,
    }
  );

  const [
    fetchDataVehiclesResource,
    { data: dataVehiclesResource }
  ] = useLazyGetVehiclesResourceQuery();

  useEffect(() => {
    const id = dataAppUser?.data?.company?.companyId;
    if (id) {
      fetchDataVehiclesResource({
        id: vehicle.vehicleId,
        params: {
          "companyId.equals": id
        }
      });
    }
  }, [dataAppUser?.data?.company?.companyId, token]);

  const [fuelNorm, setFuelNorm] = useState(null);

  useEffect(() => {
    const fuelNormValue = company?.customAugmentationEx?.reports?.fuel_norm;

    setFuelNorm(+fuelNormValue || 0);
  }, [company]);

  const [postVehicleWeekMileagesResource] = usePostVehicleWeekMileagesResourceMutation();

  const [getVehicleWeekMileages] = useLazyGetVehicleWeekMileagesResourceQuery();

  const [patchVehicleWeekMileagesResource] = usePatchVehicleWeekMileagesResourceMutation();

  const [postVehicleMonthMileagesResource] = usePostVehicleMonthMileagesResourceMutation();
  const [getVehicleMonthMileages] = useLazyGetVehicleMonthMileagesResourceQuery();
  const [patchVehicleMonthMileagesResource] = usePatchVehicleMonthMileagesResourceMutation();

  const [
    fetchTrackPoints,
  ] = useLazyGetTrackPointsResourceQuery();

  const patchVehicleWeekMileagesResourceParams = useCallback(
    ({ body, id }) => patchVehicleWeekMileagesResource({
      body,
      id
    }),
    []
  );

  const getTrackPointsResourceParams = useCallback(
    ({ params }) => fetchTrackPoints({
      authToken: token,
      params: {
        ...params
      }
    }),
    [vehicle]
  );

  const getVehicleWeekMileagesParams = useCallback(
    ({ params }) => getVehicleWeekMileages({
      params
    }),
    []
  );

  const postVehicleWeekMileagesResourceParams = useCallback(
    ({ body }) => postVehicleWeekMileagesResource({
      body
    }),
    []
  );

  const patchVehicleMonthMileagesResourceParams = useCallback(
    ({ body, id }) => patchVehicleMonthMileagesResource({
      body,
      id
    }),
    []
  );

  const getVehicleMonthMileagesParams = useCallback(
    ({ params }) => getVehicleMonthMileages({
      params
    }),
    []
  );

  const postVehicleMonthMileagesResourceParams = useCallback(
    ({ body }) => postVehicleMonthMileagesResource({
      body
    }),
    []
  );

  const [data, setData] = useState(null);

  useEffect(() => {
    const newData = {};
    newData.dataVehiclesResource = dataVehiclesResource;
    setData(newData);
  }, [
    dataVehiclesResource,
  ]);

  const props = {
    data,
    fuelNorm,
    vehicle,
    postVehicleWeekMileagesResourceParams,
    getVehicleWeekMileagesParams,
    patchVehicleWeekMileagesResourceParams,
    postVehicleMonthMileagesResourceParams,
    getVehicleMonthMileagesParams,
    patchVehicleMonthMileagesResourceParams,
    getTrackPointsResourceParams
  };

  return (
    <>
      {Children.toArray(children).map((child) => cloneElement(child, props))}
    </>
  );
}

VehicleReportingBll.propTypes = {
  children: PropTypes.element.isRequired,
  vehicle: PropTypes.shape({
    vehicleId: PropTypes.number,
  }),
  company: PropTypes.shape({
    customAugmentationEx: PropTypes.shape({
      reports: PropTypes.shape({ fuel_norm: PropTypes.string.isRequired }),
    }),
  })
};

VehicleReportingBll.defaultProps = {
  vehicle: null,
  company: null,
};

export default VehicleReportingBll;
